module.exports = __webpack_public_path__ + "static/media/21ECLAC47.3a60ae75.jpg";